<template>
  <content-block v-if="isContentBlock" v-bind="myBlock.properties" :visible="visible"/>
  <text-block v-else-if="isTextBlock" v-bind="myBlock.properties" :visible="visible"/>
  <scroll-text-block v-else-if="isScrollTextBlock" v-bind="myBlock.properties" :visible="visible"/>
  <browser-block v-else-if="isBrowserBlock" v-bind="myBlock.properties" :visible="visible"/>
  <scroll-browser-block v-else-if="isScrollBrowserBlock" v-bind="myBlock.properties" :visible="visible"/>
  <image-block v-else-if="isImageBlock" v-bind="myBlock.properties" :visible="visible"/>
  <product-block v-else-if="isProductBlock" v-bind="myBlock.properties" :visible="visible"/>
  <product-shop-block v-else-if="isProductShopBlock" v-bind="myBlock.properties" :visible="visible"/>
  <button-block v-else-if="isButtonBlock" v-bind="myBlock.properties" :visible="visible"/>
  <cart-block v-else-if="isCartBlock" v-bind="myBlock.properties" :visible="visible"/>
  <language-block v-else-if="isLanguageBlock" v-bind="myBlock.properties" :visible="visible"/>
  <language-select-block v-else-if="isLanguageSelectBlock" v-bind="myBlock.properties" :visible="visible"/>
</template>

<script>
import TextBlock from './TextBlock.vue';
import ScrollTextBlock from './ScrollTextBlock.vue';
import BrowserBlock from './BrowserBlock.vue';
import ScrollBrowserBlock from './ScrollBrowserBlock.vue';
import ImageBlock from './ImageBlock.vue';
import ProductBlock from './ProductBlock.vue';
import ProductShopBlock from './ProductShopBlock.vue';
import ButtonBlock from './ButtonBlock.vue';
import CartBlock from './CartBlock.vue';
import LanguageBlock from './LanguageBlock.vue';
import LanguageSelectBlock from './LanguageSelectBlock.vue';
import { DynamicBlockModel } from '../models';
import { dynamicBlockType } from '../constants';

export default {
  name: 'dynamic-block',
  components: {
    ButtonBlock,
    ProductBlock,
    ImageBlock,
    TextBlock,
    BrowserBlock,
    CartBlock,
    LanguageBlock,
    ScrollTextBlock,
    ScrollBrowserBlock,
    LanguageSelectBlock,
    ProductShopBlock,
    ContentBlock: () => import('./ContentBlock.vue')
  },
  props: {
    block: {
      type: Object,
      default: () => {
      }
    },
    visible: { type: Boolean, default: true },
  },
  computed: {
    myBlock() {
      return new DynamicBlockModel(this.block);
    },
    blockProps() {
      return this.myBlock.properties;
    },
    isContentBlock() {
      return this.myBlock.type === dynamicBlockType.CONTENT_BLOCK;
    },
    isBrowserBlock() {
      return this.myBlock.type === dynamicBlockType.BROWSER_BLOCK;
    },
    isScrollBrowserBlock() {
      return this.myBlock.type === dynamicBlockType.SCROLL_BROWSER_BLOCK;
    },
    isTextBlock() {
      return this.myBlock.type === dynamicBlockType.TEXT_BLOCK;
    },
    isScrollTextBlock() {
      return this.myBlock.type === dynamicBlockType.SCROLL_TEXT_BLOCK;
    },
    isImageBlock() {
      return this.myBlock.type === dynamicBlockType.IMAGE_BLOCK;
    },
    isProductBlock() {
      return this.myBlock.type === dynamicBlockType.PRODUCT_BLOCK;
    },
    isProductShopBlock() {
      return this.myBlock.type === dynamicBlockType.PRODUCT_SHOP_BLOCK;
    },
    isButtonBlock() {
      return this.myBlock.type === dynamicBlockType.BUTTON_BLOCK;
    },
    isCartBlock() {
      return this.myBlock.type === dynamicBlockType.CART_BLOCK;
    },
    isLanguageBlock() {
      return this.myBlock.type === dynamicBlockType.LANGUAGE_BLOCK;
    },
    isLanguageSelectBlock() {
      return this.myBlock.type === dynamicBlockType.LANGUAGE_SELECT_BLOCK;
    },
    hasPaginableChildren() {
      // Only allow to swipe on the last paginable child
      return this.$children.some((child) => child.isPaginableContentBlock || child.hasPaginableChildren);
    },
    isPaginableContentBlock() {
      return false;
    },
    hasScrollableChildren() {
      return this.$children.some((child) => child.isScrollableContentBlock || child.hasScrollableChildren);
    },
    isScrollableContentBlock() {
      return false;
    }
  },
};
</script>
